<template>
    <div class="showbase">
        <div class="list">
            <div class="item" v-for="(item,index) in subItemList" :key="index">
                <mVideo
                    :videoUrl="item.mediaurl"
                    :imgurl="item.icon"
                    height="3.64rem"
                    width="6.54rem"
                    fit="contain"
                ></mVideo>
                <div class="info">
                    <div>{{item.title}}</div>
                    <div class="btn" @click="onshow(item)">视频下载</div>
                </div>
            </div>
        </div>
        <van-overlay :show="show" class-name="overlay">
            <div class="wrapper">
                <div class="tit">下载链接</div>
                <div class="tag-read" >{{item.mediaurl}}</div>
                <div class="tips">复制下载链接，在浏览器输入链接即可下载</div>
                <div class="btn xxxxx" :data-clipboard-text="item.mediaurl" @click="onclose">一键复制</div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import mVideo from "@/components/mVideo/video";
import Clipboard from 'clipboard';
import { Overlay } from 'vant';
import './index.less'
export default {
    data() {
        return {
            subItemList: [],
            show: false,
            item: {}
        }
    },
    components: {mVideo,vanOverlay:Overlay},
    mounted() {
        this.$nextTick(() => {
            this.getItemInfo();
        });
    },
    methods: {
        getItemInfo() {
            this.subItemList = [];
            this.rule = "";
            this.$api.sports.getItemSubs({ itemid: this.$route.params.itemid }).then((res) => {
                this.subItemList = res.data.list;
            });
        },
        onshow(item) {
            this.show = true
            this.item = item
        },
        onclose() {
            var clipboard = new Clipboard('.xxxxx') 
            var that = this 
            this.show = false
            clipboard.on('success', e => {  
                that.$toast('复制成功')
                console.log('复制成功')  
                // 释放内存  
                clipboard.destroy()  
            })  
            clipboard.on('error', e => {  
                // 不支持复制  
                that.$toast('该浏览器不支持自动复制')
                console.log('该浏览器不支持自动复制')  
                // 释放内存  
                clipboard.destroy()  
            })  
        }
    }
}
</script>